import { useMutation, useQuery } from '@tanstack/react-query';
import { useApi } from '../../lib/ApiProvider';

/** LOT B3 — hooks du portail client. Lecture seule + une mutation « télécharger » (effet de bord Blob). */
export const portalKeys = {
  dossiers: ['portal', 'dossiers'] as const,
  dossier: (id: string) => ['portal', 'dossier', id] as const,
};

export function usePortalDossiers() {
  const api = useApi();
  return useQuery({
    queryKey: portalKeys.dossiers,
    queryFn: () => api.listPortalDossiers(),
  });
}

export function usePortalDossier(id: string | undefined) {
  const api = useApi();
  return useQuery({
    queryKey: portalKeys.dossier(id ?? ''),
    queryFn: () => api.getPortalDossier(id as string),
    enabled: Boolean(id),
  });
}

export function useDownloadPortalDocument() {
  const api = useApi();
  return useMutation({
    mutationFn: (documentId: string) => api.downloadPortalDocument(documentId),
  });
}
